<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-dedication element-with-heading full-character-formatting" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">Dedication</h1>
</div>
</div>
</div>
</div>
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">For Kaylie</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">August 13, 1986</p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>Precious Child, Beautiful Star,</i></p>
<p class="alignment-block-content alignment-block-content-center dedication-content"><i>This one’s for you.</i></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1d0259ac